(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/services/customer-info.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/services/customer-info.js');
"use strict";

const logger = svs.ticketsOrderHome.utils.logger;
const getPlayerPreferences = async () => await svs.tur.apiCaller.ticketgames.getPlayerPreferences();

const getCustomersPreferencesAsync = async () => {
  try {
    var _response$preferences;
    const {
      response
    } = await svs.ticketsOrderHome.services.getPlayerPreferences();
    if (response !== null && response !== void 0 && response.error) {
      logger.warn('Error when fetching player preferences', response === null || response === void 0 ? void 0 : response.error);
    }
    return {
      error: response === null || response === void 0 ? void 0 : response.error,
      playerPreferences: (response === null || response === void 0 || (_response$preferences = response.preferences) === null || _response$preferences === void 0 ? void 0 : _response$preferences[30]) || {}
    };
  } catch (err) {
    logger.warn('Error when fetching player preferences', err);
    return {
      error: err,
      playerPreferences: {}
    };
  }
};
setGlobal('svs.ticketsOrderHome.services.getPlayerPreferences', getPlayerPreferences);
setGlobal('svs.ticketsOrderHome.services.getCustomersPreferencesAsync', getCustomersPreferencesAsync);

 })(window);